import React from "react";
import Head from "next/head";

import EventsBlock from "@/components/shared/events-block";

export default function EventsList() {
    return (
        <div className="w-full">
            <Head>
                <title>GIÁO PHẬN PHÚ CƯỜNG - Sự kiện</title>
            </Head>
            <h2 className="font-bold text-5xl pt-5 text-center sm:text-left px-2 text-primary">
                Sự kiện
            </h2>

            <div className="sm:grid sm:grid-cols-4 py-4 gap-5 lg:gap-10 px-2">
                <div className="sm:col-span-4 bg-white p-3 h-fit shadow-lg rounded-lg">
                    <div className="flex justify-center items-center gap-4">
                        <EventsBlock/>
                    </div>
                </div>
            </div>
        </div>
    )
}
